<template lang="html">
  <div>
    <event-billing-item
      v-model="selectedItemId"
    />
    <v-card
      v-if="!showItemOnly"
      :key="instanceKey"
    >
      <page-bar
        :title="pageTitle"
        :context-menu="contextMenu"
        :loading="isDataLoading"
      />

      <api-errors :errors="errors" />

      <!-- LIST OF ITEMS -->
      <item-select-table
        :edit-action="editItem"
        :search="true"
        :items="items"
        :pagination.sync="pagination"
        :total-items="totalListItems"
        :headers="headers"
      >
        <template slot="search-filters">
          <!-- SEARCH FILTERS -->
          <v-layout wrap>
            <v-flex class="xs12 sm6 md6 px-3">
              <!-- FILTER BILLABLE -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-boolean
                      v-model="showBillableOnly"
                      label="Show Billable Events Only"
                    />
                  </div>
                </template>
                <span>Billable events are today or older that have at least one charge code configured.</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </template>
      </item-select-table>
    </v-card>
  </div>
</template>

<script>
import {itemSelect} from '@/ft-vue-core'
import EventBillingItem from './EventBillingItem'

export default {
  name: 'EventBillingList',
  components: {EventBillingItem},
  mixins: [itemSelect],
  props: {
  },
  data: function () {
    return {
      type: 'Event Billing',
      types: 'Event Billing',
      headers: [
        this.headerText('Event Name', 'name', true),
        this.headerText('Date', 'date', true),
        this.headerText('Covers', 'coverCount'),
        this.headerText('Reservations', 'activeReservationCount')
      ],
      apiRecordCommand: 'diningEvent',
      showBillableOnly: true
    }
  },
  computed: {
    contextMenu () {
      return [
        {
          title: 'Refresh List',
          icon: 'mdi-refresh',
          action: this.refreshList
        }
      ]
    }
  },
  watch: {
    showBillableOnly () {
      this.loadList()
    }
  },
  methods: {
    listSearchFilter () {
      const filters = {}
      if (this.showBillableOnly) {
        filters.filterByHasAChargeCode = []
      }
      return filters
    },
    listCommandFilter (command) {
      this.addCommandParam(command, 'filter_methods', this.listSearchFilter())
      this.addCommandParamArrayVal(command, 'include_fields', 'coverCount', 'activeReservationCount')
      return this.addCommandParam(command, 'children', true)
    }
  }
}
</script>
<style>
</style>
